/**
 * Slider init
 *
 * @since 1.0.0
 * @package gencor
 */

(function($) {
	$(document).ready(function() {
		// init support section slider
		$('#gencor-support .support-slider').slick({
			respondTo: 'slider',
			adaptiveHeight: false,
			fade: true,
			dots: true,
			infinite: true,
			verticalSwiping: true,
			autoplay: true,
			autoplaySpeed: 7500,
			arrows: true
		});

		$('.equipment-photos').slick({
		   	fade: true,
		   	dots: false,
		   	adaptiveHeight: false,
			infinite: true,
			autoplay: false,
			arrows: false
		 });
		$('.equipment-photos-nav').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: true,
			asNavFor: '.equipment-photos',
			dots: false,
			// centerMode: true,
			focusOnSelect: true,
			arrows: false
		});

		$('.variation-photos').slick({
		   	fade: true,
		   	dots: true,
		   	adaptiveHeight: false,
			infinite: true,
			autoplay: false,
			arrows: true
		 });

		$('.slider-photos').slick({
		   	fade: true,
		   	dots: true,
		   	adaptiveHeight: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 7000,
			arrows: true
		 });

		$('.event-photos').slick({
		   	fade: true,
		   	dots: true,
		   	adaptiveHeight: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 7000,
			arrows: true
		 });

	}); // document.ready

	// Below adds arrow functionality to the sliders
	$('#gencor-support .support-slider').each(function() {
		$(this).on('init', function() {
			$(this).find('.slick-dots').wrap('<span class="slick-dots-wrapper"></span>');
			$(this).find('.slick-prev').prependTo( $(this).find('.slick-dots-wrapper') );
			$(this).find('.slick-next').appendTo( $(this).find('.slick-dots-wrapper') );

		});
	});

	$('.variation-photos').each(function() {
		$(this).on('init', function() {
			$(this).find('.slick-dots').wrap('<span class="slick-dots-wrapper"></span>');
			$(this).find('.slick-prev').prependTo( $(this).find('.slick-dots-wrapper') );
			$(this).find('.slick-next').appendTo( $(this).find('.slick-dots-wrapper') );
		});
	});

	$('.event-photos').each(function() {
		$(this).on('init', function() {
			$(this).find('.slick-dots').wrap('<span class="slick-dots-wrapper"></span>');
			$(this).find('.slick-prev').prependTo( $(this).find('.slick-dots-wrapper') );
			$(this).find('.slick-next').appendTo( $(this).find('.slick-dots-wrapper') );
		});
	});

	$('.slider-photos').each(function() {
		$(this).on('init', function() {
			$(this).find('.slick-dots').wrap('<span class="slick-dots-wrapper"></span>');
			$(this).find('.slick-prev').prependTo( $(this).find('.slick-dots-wrapper') );
			$(this).find('.slick-next').appendTo( $(this).find('.slick-dots-wrapper') );
		});
	});

})(jQuery);